import moment from 'moment'

import { CloneLegalCaseGetters } from './partials/clone'
import { ClosingWizardGetters } from './partials/closing-wizard'
import { DocketEntriesGetters } from './partials/docket-entries'
import { DocketEntriesInfoGetters } from './partials/docket-entries-info'
import { ECOPortalIntegrationGetters } from './partials/eco-portal-integration'
import { EngagementLetterGetters } from './partials/engagement-letter'
import { LegalCaseEditGetters } from './partials/edit'
import { LegalCaseTagGetters } from './partials/tag'
import { ReopeningWizardGetters } from './partials/reopening-wizard'

export const LegalCaseGetters = {
  ...CloneLegalCaseGetters,
  ...ClosingWizardGetters,
  ...DocketEntriesGetters,
  ...DocketEntriesInfoGetters,
  ...ECOPortalIntegrationGetters,
  ...EngagementLetterGetters,
  ...LegalCaseEditGetters,
  ...LegalCaseTagGetters,
  ...ReopeningWizardGetters,

  currentLegalCase: state => state.legalCases.find(lc => lc.id === state.currentLegalCaseId),
  currentLegalCases: state => state.legalCases,
  legalCase: state => state.legalCase,
  legalCaseOptionsList: state => state.legalCaseOptionsList,
  legalCaseParties: state => state.legalCase.parties,
  legalCaseUnassociatedParties: state => state.legalCaseUnassociatedParties,
  legalCases: state => state.legalCases,
  legalCasesIds: state => state.legalCases.map(item => item.id),
  legalCasesPartySliderSettings: state => state.partySliderSettings,

  orderedLegalCases: state => {
    const currentLegalCasesWeights = state.legalCases.sort((a, b) => {
      const bDate = moment(b.last_created_docket_entry_date, 'MM/DD/YYYY')
      const aDate = moment(a.last_created_docket_entry_date, 'MM/DD/YYYY')
      if (aDate.isBefore(bDate)) return 1
      return aDate.isSame(bDate) ? 0 : -1
    }).reduce((p, c, i) => {
      p[c.id] = i * (c.closed ? 1 : -1)
      return p
    }, {})

    return state.legalCases.sort((a, b) => currentLegalCasesWeights[a.id] - currentLegalCasesWeights[b.id])
  },

  paginationOptions: state => state.paginationOptions,
  showAssociatePartyDialog: state => state.showAssociatePartyDialog,
}
